import classNames from 'classnames';

import VideoPlayer from 'hb-react/frontoffice/components/VideoPlayer';
import { topicElementIsVisibleOnPublicPage } from 'hb-react/shared/apps/Topics/utils/topicElementIsVisibleOnPublicPage';

import style from '../index.module.scss';

const Description = ({ currentUser, topic }) => (
  <div
    className={`grid grid--full soft-double--bottom ${style['homepage-container']}`}
  >
    {topic.video_url &&
      topicElementIsVisibleOnPublicPage(currentUser, topic, 'video') && (
        <div className="grid__item two-fifths">
          <VideoPlayer controls url={topic.video_url} />
        </div>
      )}
    <div
      className={classNames('grid__item', {
        'three-fifths': topic.video_url,
        'one-whole': !topic.video_url,
      })}
    >
      {topic.description &&
        topicElementIsVisibleOnPublicPage(
          currentUser,
          topic,
          'description',
        ) && (
          <div className="push-half--bottom soft-double-half">
            <h2 className="h1 flex flex--justify-center">{__('About')}</h2>
            <div>
              <div
                className={`ckeditor-content--reset ${style.description}`}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: topic.description }}
              />
            </div>
          </div>
        )}
    </div>
  </div>
);

export default Description;
